export default __webpack_public_path__ + "static/media/orion.8d4ef08b.svg";